import { render, staticRenderFns } from "./StringboxFarmCompariton.vue?vue&type=template&id=4d28faa5&scoped=true&"
import script from "./StringboxFarmCompariton.vue?vue&type=script&lang=js&"
export * from "./StringboxFarmCompariton.vue?vue&type=script&lang=js&"
import style0 from "./StringboxFarmCompariton.vue?vue&type=style&index=0&id=4d28faa5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d28faa5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VDatePicker,VDivider,VMenu,VRow,VSelect,VSpacer,VTextField})
